import { useEffect, useState } from "react";
import api from "../api/axios";
import AppShell from "../components/AppShell";

// One reusable page for every demo backend module. In a real app each of
// these (`/users`, `/orders`, etc.) would be its own richer page, but they'd
// all follow this same pattern: call the endpoint, and let the backend's
// checkPermission middleware be the real gatekeeper.
export default function FeaturePage({ title, endpoint }) {
  const [state, setState] = useState({ loading: true, error: "", data: null });

  useEffect(() => {
    let mounted = true;
    api
      .get(endpoint)
      .then(({ data }) => mounted && setState({ loading: false, error: "", data }))
      .catch((err) =>
        mounted &&
        setState({
          loading: false,
          error: err.response?.data?.message || "Failed to load",
          data: null,
        })
      );
    return () => {
      mounted = false;
    };
  }, [endpoint]);

  return (
    <AppShell>
      <h1 style={styles.title}>{title}</h1>
      {state.loading && <p style={styles.muted}>Loading…</p>}
      {state.error && <div style={styles.error}>{state.error}</div>}
      {state.data && (
        <div style={styles.card}>
          <p style={styles.msg}>{state.data.message}</p>
          <p style={styles.muted}>
            This confirms your account's assigned permissions unlocked this module on the backend.
          </p>
        </div>
      )}
    </AppShell>
  );
}

const styles = {
  title: { fontFamily: "var(--font-display)", fontSize: 26, marginBottom: 20 },
  muted: { color: "var(--slate-500)", fontSize: 13 },
  error: {
    background: "rgba(217,99,78,0.1)",
    border: "1px solid var(--danger)",
    color: "#a8402c",
    padding: "10px 14px",
    borderRadius: 4,
    fontSize: 13,
  },
  card: { background: "#fff", border: "1px solid var(--line)", borderRadius: 6, padding: 20, maxWidth: 480 },
  msg: { fontSize: 15, marginTop: 0 },
};
